import ReactDOM from 'react-dom'
import React from 'react'
import Content from './Content'
import Sidebar from './Sidebar'
import ReservationPage from './ReservationPage'
import { ReservationProvider } from './ReservationContext'
import CheckoutRecoveryProvider from './checkoutRecovery/CheckoutRecoveryProvider'
import { readRecoveryBootstrap } from './checkoutRecovery/recoveryData'
import './i18n'

let root = document.getElementById('reservation_container')

if (root) {
    const bootstrap = readRecoveryBootstrap(document)

    const application = bootstrap.enabled ? (
        <CheckoutRecoveryProvider bootstrap={bootstrap}>
            <ReservationPage />
        </CheckoutRecoveryProvider>
    ) : (
        <ReservationProvider>
            <div className="trip-reservation">
                <Sidebar />
                <Content />
            </div>
        </ReservationProvider>
    )

    ReactDOM.render(application, root)
}
